<template>
  <div
    v-if="recentlyDelivered.length > 0"
    class="text-center"
  >
    <el-table
      size="mini"
      :data="visibleRecentlyDelivered"
      stripe
    >
      <el-table-column
        label="Consignment"
        width="140"
      >
        <template slot-scope="scope">
          <a
            :href="getTrackingLink(scope.row.id)"
            target="_top"
          >
            {{ scope.row.consignment }}
          </a>
        </template>
      </el-table-column>

      <el-table-column
        label="Delivered At"
        min-width="120"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.delivered_at | moment('D MMMM YYYY h:mm A') }}
        </template>
      </el-table-column>
    </el-table>

    <div class="clearfix" />

    <el-pagination
      class="pt-4 w-100 text-center"
      layout="prev, pager, next"
      :pager-count="5"
      :page-size="pageSize"
      :current-page.sync="currentPage"
      :total="totalRecentlyDelivered"
      small
      background
      hide-on-single-page
      @current-change="setCurrentPage"
    />
  </div>

  <div
    v-else
    class="text-center text-muted font-italic p-3"
  >
    No Data
  </div>
</template>

<script>
export default {
  props: {
    recentlyDelivered: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      pageSize: 6,
      currentPage: 1
    }
  },
  computed: {
    totalRecentlyDelivered () {
      return this.recentlyDelivered.length
    },
    visibleRecentlyDelivered () {
      const currentPage = this.currentPage
      const pageSize = this.pageSize
      const recentlyDelivered = this.recentlyDelivered

      return recentlyDelivered.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    }
  },
  methods: {
    formatNumber (value) {
      return (new Intl.NumberFormat('en-US')).format(value)
    },
    getTrackingLink (id) {
      return process.env.VUE_APP_LEGACY_SHIPPER_URI + 'track/' + id
    },
    setCurrentPage (page) {
      this.currentPage = page
    }
  }
}
</script>
